import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=dbd6e58a&scoped=true&"
import script from "./ContactItem.vue?vue&type=script&lang=js&"
export * from "./ContactItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactItem.vue?vue&type=style&index=0&id=dbd6e58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd6e58a",
  null
  
)

export default component.exports